// @flow
import WebComponent          from 'fg-frontend/src/webComponents/WebComponent';
import PhotoSwipeConstructor from 'photoswipe';
import PhotoSwipeUI_Default  from 'photoswipe/dist/photoswipe-ui-default';

const fragments = {
	ITEM: '[data-fragment="PhotoSwipe.item"]',
};

class PhotoSwipe extends WebComponent {
	constructor(props) {
		super(props);
		this.parseThumbnailElements = this.parseThumbnailElements.bind(this);
		this.onThumbnailsClick = this.onThumbnailsClick.bind(this);
		this.photoswipeParseHash = this.photoswipeParseHash.bind(this);
		this.openPhotoSwipe = this.openPhotoSwipe.bind(this);
	}

	didMount() {
		const { layoutSelector } = this.props;
		this.on('click', fragments.ITEM, this.onThumbnailsClick);
		this.items = this.parseThumbnailElements();
		this.layout = document.querySelector(layoutSelector);
		if ( !this.layout ) {
			throw Error('V HTML kódu chybí photoSwipe element!');
		}
		// Parse URL and open gallery if it contains #&pid=3&gid=1
		const hashData = this.photoswipeParseHash(window.location.hash.substring(1));
		if ( hashData.pid && hashData.gid ) {
			this.openPhotoSwipe(hashData.pid - 1);
		}
	}

	willUnmount() {
		this.items = null;
		this.layout = null;
		if ( this.gallery ) {
			this.gallery.destroy();
		}
	}

	// parse slide data (url, title, size ...) from DOM elements
	parseThumbnailElements() {
		const items = [ ...this.element.querySelectorAll(fragments.ITEM) ];
		const itemsData = items.map((itemElement) => {
			const [ w, h ] = itemElement.dataset.size.split('x');
			const img = itemElement.querySelector('img');
			return {
				src:   itemElement.href,
				w:     parseInt(w, 10),
				h:     parseInt(h, 10),
				msrc:  itemElement.href,
				title: img.alt,
				el:    itemElement,
			};
		});
		return itemsData;
	}

	// triggers when user clicks on thumbnail
	onThumbnailsClick(e) {
		e.preventDefault();
		e.stopPropagation();
		const index = e.currentTarget.dataset.index;
		this.openPhotoSwipe(index);
	}

	// parse picture index and gallery index from URL (#&pid=1&gid=2)
	photoswipeParseHash(hash) {
		let params = {};
		if ( hash.length < 5 ) {
			return params;
		}
		const vars = hash.split('&');
		vars.forEach(function (varItem) {
			let [ key, value ] = varItem.split('=');
			params[ key ] = value;
		});
		return params;
	}

	openPhotoSwipe(index) {
		let actIndex = parseInt(index, 10);
		if ( isNaN(actIndex) ) {
			actIndex = 0;
		}
		if ( index < 0 ) {
			return;
		}
		const { showAnimationDuration } = this.props;
		// define options (if needed)
		const options = {
			...this.props,
			index:                 actIndex,
			showAnimationDuration: showAnimationDuration,
			getThumbBoundsFn:      false,
			showHideOpacity:       true,
		};
		this.gallery = new PhotoSwipeConstructor(this.layout, PhotoSwipeUI_Default, this.items, options);
		this.gallery.init();
	}
}

PhotoSwipe.defaultProps = {
	showAnimationDuration: 333,
	layoutSelector:        '.pswp',
};

export default PhotoSwipe;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/PhotoSwipe.js